// Helper untuk log akses menu Ormas Badan Hukum (Polpum).
// Dipakai di halaman tab "Ormas Badan Hukum" (Domisili & Nasional) dan handler
// search/detail Perkumpulan/Yayasan/Badan Hukum. Skip kalau user belum login.
import act from '@/act_constants';
import store from '@/core/services/store';

function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch (_e) {
    return {};
  }
}

function formatWaktu(d) {
  // Output: "01/05/26 14.32" (id-ID locale)
  return d.toLocaleString('id-ID', { dateStyle: 'short', timeStyle: 'short' });
}

function compose(template, nama, entitas, waktu) {
  return template
    .replace('_NAMA_', nama || '-')
    .replace('_ENTITAS_', entitas || '-')
    .replace('_WAKTU_', waktu);
}

const TYPE_TEMPLATE = {
  bakum_list: act.ACT_BAKUM_LIST,
  bakum_detail: act.ACT_BAKUM_DETAIL,
  bakum_search: act.ACT_BAKUM_SEARCH,
  perkumpulan_search: act.ACT_PERKUMPULAN_SEARCH,
  yayasan_search: act.ACT_YAYASAN_SEARCH,
  bakum_detail_ahu: act.ACT_BAKUM_DETAIL_AHU,
  bakum_download: act.ACT_BAKUM_DOWNLOAD
};

const TYPE_TARGET = {
  bakum_list: 'ormas_badan_hukum',
  bakum_detail: 'ormas_badan_hukum',
  bakum_search: 'badan_hukum',
  perkumpulan_search: 'perkumpulan',
  yayasan_search: 'yayasan',
  bakum_detail_ahu: 'badan_hukum',
  bakum_download: 'ormas_badan_hukum'
};

// Verb pendek untuk kolom "Aktivitas" pada halaman Log Aktivitas (sesuai desain tabel).
const ACTION_LABEL = {
  bakum_list: 'Pencarian',
  bakum_search: 'Pencarian',
  perkumpulan_search: 'Pencarian',
  yayasan_search: 'Pencarian',
  bakum_detail: 'Membuka',
  bakum_detail_ahu: 'Membuka',
  bakum_download: 'Mengunduh'
};

// Isi kolom "Data" pada halaman Log Aktivitas. _ENTITAS_ = kata kunci / nama entitas.
const DATA_TEMPLATE = {
  bakum_search: '_ENTITAS_',
  perkumpulan_search: '_ENTITAS_',
  yayasan_search: '_ENTITAS_',
  bakum_list: 'Daftar Ormas Badan Hukum (kata kunci: _ENTITAS_)',
  bakum_detail: 'Detail Ormas Badan Hukum _ENTITAS_',
  bakum_detail_ahu: 'Detail Badan Hukum(AHU) _ENTITAS_',
  bakum_download: 'Data Ormas Badan Hukum _ENTITAS_'
};

/**
 * Catat akses ke audit service.
 * @param {string} type — salah satu key dari TYPE_TEMPLATE (bakum_list/bakum_detail/...).
 * @param {string} entitas — kata kunci pencarian atau nama entitas.
 */
export function logBakumAccess(type, entitas) {
  if (!localStorage.getItem('token')) return; // landing public, skip
  const user = getCurrentUser();
  if (!user || !user.id) return;

  const template = TYPE_TEMPLATE[type];
  if (!template) return;

  const keyword = entitas != null ? String(entitas).trim() : '';
  if (!keyword) return; // jangan spam log untuk auto-load tanpa keyword

  const now = new Date();
  const nama = user.nama_lengkap || user.username || '-';
  const roleName = (user.roles_full && user.roles_full[0] && user.roles_full[0].role_name) || '-';
  const targetType = TYPE_TARGET[type] || 'badan_hukum';

  const dataTemplate = DATA_TEMPLATE[type] || '_ENTITAS_';

  store.dispatch('storeActivitySilent', {
    user_id: String(user.id),
    activity: compose(template, nama, keyword, formatWaktu(now)),
    category: 'BAKUM_ACCESS',
    role_name: roleName,
    nama_lengkap: nama,
    target_type: targetType,
    target_keyword: keyword,
    // Field tambahan untuk halaman Log Aktivitas (model audit non-strict, disimpan apa adanya).
    action_label: ACTION_LABEL[type] || 'Akses',
    data_label: dataTemplate.replace('_ENTITAS_', keyword)
  });
}
